/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment, useMemo } from 'react';
import HeaderCome from './headercome';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Load from './load';
import { ImagePath } from '../helper/constants';
import LazySection from '../components/about/LazySection';
import { useCareerData } from '../hooks/useCareerData';
import { useLocation } from 'react-router-dom';
import { SeoData } from '../types/seodata';
export interface CareerSlider {
    id: string;
    title: string;
    description: string;
    slider_images: any[];
}
const CareersNew: React.FC = () => {
  const { pathname } = useLocation();
    localStorage.removeItem("CareerformTitle");
      const pageSEO = SeoData.find((page) => page.url === pathname);
    const { data, loading, error } = useCareerData();
    const imagePath = ImagePath;
const slides = data?.slider?.data?.slider_images ?? [];
    if (loading) return <Load />;
    // if (error) return <div>Error: {error}</div>;
    const content = data?.about3?.field_content?.[0]?.value;
    const content1 = data?.about2?.field_content?.[0]?.value;
   
 const formTitle = data?.about3?.field_ctitle?.[0]?.value ?? "";
  
localStorage.setItem("CareerformTitle", formTitle);

    return (
       
  <>
    {!loading && pageSEO && (
        <>
            <Fragment>
              <head>
            {/* ✅ Primary Title */}
              {pageSEO?.recommended_title && <title>{pageSEO?.recommended_title}</title>}
              {/* ✅ Meta Description */}
              {pageSEO?.recommended_title && <meta name="title" content={pageSEO?.recommended_title} />}

              {/* ✅ Meta Description */}
              {pageSEO?.meta_description && <meta name="description" content={pageSEO?.meta_description} />}

              {/* ✅ Secondary Meta (Suggested Description) */}
              {pageSEO?.suggested_desc && <meta name="summary-description" content={pageSEO?.suggested_desc} />}
              
                {/* ✅ Secondary Meta (Suggested h1) */}
              {pageSEO?.suggested_h1 && <meta name="summary-h1" content={pageSEO?.suggested_h1} />}
            
              {/* ✅ Canonical URL */}
              {pageSEO?.canonical && <link rel="canonical" href={`${pageSEO?.canonical}`} />}

              {/* ✅ Open Graph */}
              {pageSEO?.recommended_title && <meta property="og:title" content={pageSEO?.recommended_title} />}
              {pageSEO?.meta_description && (
                <meta property="og:description" content={pageSEO?.meta_description} />
              )}
              {pageSEO?.canonical && <meta property="og:url" content={`${pageSEO?.canonical}`} />}
              <meta property="og:type" content="website" />

              {/* ✅ Twitter Meta */}
              <meta name="twitter:card" content="summary_large_image" />
              {pageSEO?.recommended_title && <meta name="twitter:title" content={pageSEO?.recommended_title} />}
              {pageSEO?.meta_description && (
                <meta name="twitter:description" content={pageSEO?.meta_description} />
              )}
           </head>
          </Fragment>
        
              {pageSEO?.suggested_h1 &&<h1 style={{
                  position: "absolute",
                  width: 1,
                  height: 1,
                  overflow: "hidden",
                  clip: "rect(0 0 0 0)",
                }}>{pageSEO?.suggested_h1}</h1>}
        </>
      )}

            <main className="main">

                {/* Hero Section */}
                <section id="hero" className="hero section career-hero dark-background career-banner">
                    <img src={data?.heroImg?.thumbnail?.[0]?.url || ""} alt="" className="hero-bg d-lg-block d-md-block d-sm-block w-100" loading="lazy" decoding="async" />
                     {/* <img src={data?.heroImgmob?.thumbnail?.[0]?.url} alt="" className="hero-bg d-md-none d-sm-block w-100" loading="lazy" decoding="async" /> */}

                    <div className="container">
                        <div className="row gy-4  justify-content-between">

                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex flex-column text-md-start text-sm-center justify-content-center" data-aos="fade-in">
                                <label data-aos="slide-right" className="career-title-banner banner-h1">
                                    {data?.about?.field_content?.[0]?.value?.replace(/<\/?p>/g, '') || ""}
                                    <span>   {data?.about?.field_description?.[0]?.value || ""}</span>
                                </label>


                            </div>

                        </div>
                    </div>


                </section>{/* /Hero Section */}
                {/* About career Section */}
                <section id="about" className="about section pt-3 pt-md-5">

                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row gx-2 align-items-xl-start gy-md-5 ">

                            <div className="col-xl-4 content mt-md-4 mt-sm-0">
                                {/*<h3>About Us</h3>*/}
                                <label className="label-title">
                                    {data?.about2?.field_ctitle?.[0]?.value || ""} <span> {data?.about2?.field_sub_ctitle?.[0]?.value || ""}</span>
                                </label>
                            </div>

                            <div className="col-xl-8">
                                <div className="row gy-4 icon-boxes">
                                    <div className="col-sm-12">
                                        <p>{data?.about2?.field_description?.[0]?.value || ""}</p>
                                        <p dangerouslySetInnerHTML={{ __html: content1 || "" }} />

                                    </div>

                                </div>
                            </div>

                        </div>


                        <div className="row gx-2">
                            <div className="col-sm-12">
                                {/* Testimonials Section */}
                                <div id="testimonials" className="testimonials section  careers-slide">

                                    <div className="container-fluid" data-aos="fade-up" data-aos-delay="100">

                                        <div className="swiper init-swiper">
                                            <div className="swiper-wrapper">
                                                {/* The JSON configuration for Swiper */}
                                                <Swiper
                                                    slidesPerView={3}              // 👈 Show 3 images at once
                                                    spaceBetween={20}
                                                    pagination={{ clickable: true }}
                                                    modules={[Pagination]}
                                                    breakpoints={{
                                                        320: {
                                                            slidesPerView: 1,
                                                        },
                                                        640: {
                                                            slidesPerView: 2,
                                                        },
                                                        1024: {
                                                            slidesPerView: 3,
                                                        },
                                                    }}
                                                >
                                                    {slides?.map((slide: any, idx: number) => (
                                                        <SwiperSlide key={slide.id ?? idx}>

                                                            <div className="swiper-slide">
                                                                <div className="testimonial-item">
                                                                    <img src={`${imagePath}${slide?.slider_img_url}`} className="testimonial-img career-img" alt={slide?.slider_img_url} loading="lazy" decoding="async" />

                                                                    <p className="carrerpara" dangerouslySetInnerHTML={{ __html: slide?.slider_desc || "" }} />

                                                                </div>
                                                            </div>{/* End testimonial item */}
                                                        </SwiperSlide>
                                                    ))}
                                                    {/* <SwiperSlide>
                                        <div className="swiper-slide swiper-slide-active">
                                            <div className="testimonial-item">
                                                <img src="assets/img/career2.png" className="testimonial-img" alt="" />

                                                <p>Happy minds at work – where teamwork meets joy and productivity.</p>

                                            </div>
                                        </div>
</SwiperSlide>    <SwiperSlide>
                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <img src="assets/img/career3.png" className="testimonial-img" alt="" />
                                                <p>Celebrating success together – work hard, party harder!</p>
                                            </div>
                                        </div>
</SwiperSlide>    <SwiperSlide>
                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <img src="assets/img/career1.png" className="testimonial-img" alt="" />
                                                <p>Collaboration in action – stronger together, achieving more as one team.</p>


                                            </div>
                                        </div>
</SwiperSlide>    <SwiperSlide>
                                        <div className="swiper-slide">
                                            <div className="testimonial-item">
                                                <img src="assets/img/career2.png" className="testimonial-img" alt="" />
                                                <p>Happy minds at work – where teamwork meets joy and productivity.</p>

                                            </div>
                                        </div>
</SwiperSlide> */}
                                                </Swiper>
                                            </div>
                                            <div className="swiper-pagination"></div>

                                        </div>

                                    </div>

                                </div>{/* /Testimonials Section */}

                            </div>
                        </div>

                        <hr />
                        <div className="row  align-items-xl-start gy-md-5 mt-4">

                            <div className="col-xl-12 content mt-4">
                                {/*<h3>About Us</h3>*/}
                                <label className="label-title">
                                    {data?.about3?.field_description?.[0]?.value || ""}
                                </label>
                            </div>

                            <div className="col-xl-6 col-sm-12">
                                <img src={data?.heroImg2?.thumbnail?.[0]?.url || ""} className="img-fluid" loading="lazy" decoding="async" />
                            </div>
                            <div className="col-xl-6 col-sm-12">
                                <div className="row gy-4 icon-boxes">
                                    <div className="col-sm-12 px-lg-5" dangerouslySetInnerHTML={{ __html: content || "" }} />


                                </div>
                            </div>

                        </div>




                    </div>

                </section>{/* /About Section */}

            </main>
        </>
    );
};

export default CareersNew;